import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Menu } from 'src/app/types';
import { ParentMenu } from 'src/app/types/Menu';
import { MenuService } from '../menu.service';

@Component({
  selector: 'app-mobile-nav',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
})
export class MobileNavComponent {
  protected readonly router = inject(Router);
  protected readonly menuService = inject(MenuService);

  readonly isOpen = input(false);
  readonly menus = input<Menu[]>([]);
  readonly parentClubLogo = input('');
  readonly clubName = input('');
  readonly roleType = input('');
  readonly isSuperUserLoggedIn = input(false);
  readonly isBookingTabActive = input(false);
  readonly closeNavigation = output<void>();
  readonly logoutRequested = output<void>();

  protected readonly selectedMenuIndex = signal(-1);
  protected readonly selectedSubMenuIndex = signal(-1);
  protected readonly selectedParentMenuIndex = signal(-1);
  protected readonly superMenuSelected = signal(false);

  protected closeNav(): void {
    this.closeNavigation.emit();
  }

  protected onSuperUserClick(): void {
    this.router.navigate(['dashboard/superUserDashboardComponent']);
    this.menuService.switchToSuperUserMenus();
    this.superMenuSelected.set(true);
    this.closeNav();
  }

  protected toggleSubmenu(menu: Menu, index: number): void {
    if (menu.subMenu.length === 0) {
      this.router.navigate([menu.route]);
      this.selectedMenuIndex.set(index);
      this.selectedSubMenuIndex.set(-1);
      this.selectedParentMenuIndex.set(-1);
      this.closeNav();
    } else {
      menu.isClicked = !menu.isClicked;
      this.selectedMenuIndex.set(index);
      this.menus().forEach((m, i) => {
        if (i !== index) m.isClicked = false;
      });
    }
  }

  protected subMenuRoute(subMenu: ParentMenu, subIndex: number, parentIndex: number): void {
    this.router.navigate([subMenu.route]);
    this.selectedSubMenuIndex.set(subIndex);
    this.selectedMenuIndex.set(parentIndex);
    this.selectedParentMenuIndex.set(parentIndex);
    this.closeNav();
  }

  protected isParentMenuSelected(index: number): boolean {
    return this.selectedParentMenuIndex() === index && this.selectedSubMenuIndex() !== -1;
  }

  protected onLogout(): void {
    this.closeNav();
    this.logoutRequested.emit();
  }
}
